export const activityOptions = [
  {
    text: 'Sedentary (little or no exercise)',
    value: 1.2,
  },
  {
    text: 'Mild (Exercise 1-3 days per week)',
    value: 1.375,
  },
  {
    text: 'Moderate (Exercise 3-4 days per week)',
    value: 1.55,
  },
  {
    text: 'High (Exercise 5-7 days per week)',
    value: 1.7,
  },
]

export const genderOptions = [
  {
    text: 'FEMALE',
    value: 'F',
  },
  {
    text: 'MALE',
    value: 'M',
  },
]



// WEBPACK FOOTER //
// ./src/utils/options.js